/** Mensaje cuando GCP no tiene el origen actual en «Authorized JavaScript origins». */
export function googleSignInOriginErrorMessage(clientId = '') {
  const origin =
    typeof window !== 'undefined' && window.location?.origin
      ? window.location.origin
      : '';
  const clientHint = clientId
    ? `Verificá que en GCP editás el cliente OAuth cuyo ID termina en …${String(clientId).slice(-24)}.`
    : 'Debe coincidir con REACT_APP_GOOGLE_CLIENT_ID / GOOGLE_CLIENT_ID en Vercel.';
  if (!origin) {
    return 'No se pudo abrir Google Sign-In. Configurá el origen de la app en Google Cloud → OAuth client → Authorized JavaScript origins.';
  }
  const extraOrigins =
    origin === 'https://contsuite.com.ar'
      ? ' Si entrás por www, agregá también https://www.contsuite.com.ar.'
      : origin === 'https://www.contsuite.com.ar'
        ? ' Agregá también https://contsuite.com.ar si usás el dominio sin www.'
        : '';
  return [
    `Google no autorizó el origen de esta pestaña:`,
    origin,
    '',
    'En Google Cloud Console → APIs & Services → Credentials → cliente OAuth (Web), en Authorized JavaScript origins agregá ese origen exacto (sin barra final).',
    clientHint,
    extraOrigins,
    'Los cambios pueden tardar unos minutos.',
  ]
    .filter(Boolean)
    .join('\n');
}

/** Errores de Google Sign-In (no siempre son de origen). */
export function googleSignInErrorMessage({ clientId = '', reason = 'google' } = {}) {
  if (reason === 'not_ready') {
    return 'Google Sign-In todavía se está cargando. Esperá unos segundos y probá de nuevo.';
  }
  if (reason === 'cancelled') {
    return 'Cancelaste el acceso con Google. Podés intentarlo otra vez.';
  }
  return googleSignInOriginErrorMessage(clientId);
}
